import React from 'react';
import propTypes from 'prop-types';
import { get } from 'lodash';
import { TextInput as CrateTextInput } from '@tcc/crate';

const TextInput = ({
  className,
  dataTestId,
  label,
  onBlur,
  onChange,
  onClick,
  onReset,
  validationResult,
  value,
  placeholder,
  children,
  ...ownProps // defaultValue, disabled, key, placeholder, readOnly, size
}) => {

  const isInvalid = get(validationResult, 'isInvalid', false);
  const resultedFromUserInput = get(validationResult, 'resultedFromUserInput', false);
  const helpMessage = get(validationResult, 'helpMessages[0]', null);

  return (
    <CrateTextInput
      className={className}
      error={isInvalid && resultedFromUserInput && helpMessage}
      label={label}
      onBlur={onBlur}
      onChange={onChange}
      onClick={onClick}
      onReset={onReset}
      placeholder={placeholder}
      showLabel={!!label}
      showReset={!!onReset}
      testId={dataTestId}
      value={value}
      {...ownProps}>
      {children}
    </CrateTextInput>
  );
};
TextInput.propTypes = {
  className: propTypes.string,
  dataTestId: propTypes.string.isRequired,
  label: propTypes.oneOfType([propTypes.object, propTypes.string]),
  onBlur: propTypes.func,
  onChange: propTypes.func,
  onClick: propTypes.func,
  onClose: propTypes.func,
  onReset: propTypes.func,
  placeholder: propTypes.string,
  validationResult: propTypes.object,
  value: propTypes.string,
  children: propTypes.node
};
export default TextInput;
